<script>
import { services } from '@utils/common-services'
import { appConfig } from '@src/app.config'
import KnobControl from 'vue-knob-control'
import axios from 'axios'
export default {
  components: { KnobControl },
  props: {
    createMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
    editMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
    tab: {
      type: String,
      default() {
        return null
      },
    },
    deleteMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      formapi: appConfig.apiUrl.split('/api/'),
      trySpin: false,
      roleName: null,
      deleteId: null,
      sortBy: 'created_at',
      sortDesc: true,
      totalCount: 0,
      permissions: null,
      loading: false,
      callFunction: null,
      location: null,
      permission: [],
      applicantId: null,
      message: null,
      resendValidation: false,
      downloadLoader: false,
      perPage: 10,
      currentPage: 1,
      confirmation: null,
      errorShow: null,
      loadLocation: null,
      search: null,
      currentTab: null,
      currentStatus: null,
      links: null,
      selected: [], // Must be an array reference!
      options: [],
      fields: [
        'firstApplicant',
        'secondApplicant',

        'phoneNumber',
        'location',
        'status',
        'created_at',
        'action',
      ],
      tabIndex: 0,
      tabs: [
        'total-applicants',
        'invited',
        'completed',
        'joined',
        'verified',
        'submitted',
        'archived',
        'rejected',
      ],
      statusList: {
        all: { url: '#total-applicants', name: 'all', code: '' },
        invited: { url: '#invited', name: 'invited', code: 'invited' },
        completed: {
          url: '#completed',
          name: 'completed',
          code: 'completed',
        },
        joined: { url: '#joined', name: 'joined', code: 'joined' },
        to_be_verified: {
          url: '#verified',
          name: 'verified',
          code: 'verified',
        },
        submitted: {
          url: '#submitted',
          name: 'submitted',
          code: 'submitted',
        },
        archived: {
          url: '#archived',
          name: 'archived',
          code: 'archived',
        },
        rejected: {
          url: '#rejected',
          name: 'rejected',
          code: 'rejected',
        },
      },
    }
  },
  watch: {
    location(newVal, oldVal) {
      //  console.log(this.location)
      if (newVal !== oldVal)
        if (this.location === null || this.location === 'all')
          this.loadLocation = ''
        else if (this.location === 'GB')
          this.loadLocation = '&filter[location]=GB'
        else this.loadLocation = '&filter[location]=GBS'
      this.getPageLoad()
    },
  },

  beforeMount() {
    //  if (this.editMenu || this.deleteMenu) this.fields.push('action')
    // console.log(this.location+'-'+this.tab)
    if (this.tab === 'all') {
      this.location = 'all'
      this.loadLocation = ''
      this.getApplicants('#total-applicants')
    } else {
      if (this.location === null || this.location === 'all')
        this.loadLocation = ''
      else if (this.location === 'GB')
        this.loadLocation = '&filter[location]=GB'
      else this.loadLocation = '&filter[location]=GBS'

      this.getPageLoad()
    }
  },
  beforeDestroy() {
    // this.$store.commit('jv/clearRecords', { _jv: { type: 'applicant_profile' } })
    this.$store.commit('jv/clearRecords', {
      _jv: { type: 'resend_invitation' },
    })
  },
  mounted() {
    this.$watch(
      'selected',
      function() {
        this.resendValidation = false
      },
      { deep: true }
    )
  },
  methods: {
    getPageLoad() {
      var url = window.location.href.split('#')
      if (this.location === null && url.length === 3) this.location = url[2]

      this.tabIndex = this.tabs.findIndex((tab) => tab === url[1])

      if (this.tabIndex === -1) this.getApplicants('#total-applicants')
      else {
        if (this.location !== null) {
          if (this.location === 'all')
            window.history.replaceState(null, null, url[0] + '#' + url[1])
          else
            window.history.replaceState(
              null,
              null,
              url[0] + '#' + url[1] + '#' + this.location
            )
        }
        if (this.tabIndex === 1) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=invited&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'invited'
          this.currentStatus = 'invited'
        } else if (this.tabIndex === 0) {
          this.getUsers(
            '/applicant/profile?include=user,partner&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'all'
          this.currentStatus = 'all'
        } else if (this.tabIndex === 2) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=completed' +
              this.loadLocation
          )
          this.currentTab = 'completed'
          this.currentStatus = 'completed'
        } else if (this.tabIndex === 3) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=joined&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'joined'
          this.currentStatus = 'joined'
        } else if (this.tabIndex === 5) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=submitted&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'submitted'
          this.currentStatus = 'submitted'
        } else if (this.tabIndex === 6) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[isArchived]=true' +
              this.loadLocation
          )
          this.currentTab = 'archived'
          this.currentStatus = 'archived'
        } else if (this.tabIndex === 4) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=verified&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'verified'
          this.currentStatus = 'verified'
        } else if (this.tabIndex === 7) {
          this.getUsers(
            'applicant/profile?include=user,partner&filter[status]=rejected&filter[isArchived]=false' +
              this.loadLocation
          )
          this.currentTab = 'rejected'
          this.currentStatus = 'rejected'
        }
      }
    },
    getApplicants(name) {
      var url = window.location.href.split('#')
      //    console.log(url)
      if (
        (this.location === null || this.location === 'all') &&
        url.length === 3
      )
        this.location = url[2]
      if (this.location !== null && this.location !== 'all')
        window.history.replaceState(
          null,
          null,
          url[0] + name + '#' + this.location
        )
      else window.history.replaceState(null, null, url[0] + name)
      this.getPageLoad()
    },
    moveToArchived(requestPayload) {
      this.$store
        .dispatch('jv/patch', [
          requestPayload,
          {
            url: '/applicant/profile/' + this.applicantId + '/archive',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.$bvModal.hide('delete')
          this.message = 'Requested changes updated'
          this.errorShow = false
          this.$bvToast.show('deleteRecord')
          this.getPageLoad()
          var parent = this
          setTimeout(() => {
            parent.errorShow = false
            parent.$bvToast.hide('deleteRecord')
            parent.message = null
          }, 6000)
        })
        .catch((error) => {
          if (error) {
            this.$bvModal.hide('delete')
            this.message = error.response.data.errors[0].detail
            this.errorShow = true
            this.$bvToast.show('deleteRecord')

            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('deleteRecord')
              parent.message = null
            }, 6000)
          }
          //   console.log(error)
        })
    },
    callMethod(name) {
      var requestPayload = null
      if (name === 'resend') this.resendInvitation()
      else if (name === 'delete') this.deleteRecord()
      else if (name === 'archived') {
        requestPayload = {
          isArchived: true,

          _jv: {
            type: 'applicant_profile',
            id: this.applicantId,
          },
        }
        this.moveToArchived(requestPayload)
      } else {
        if (name === 'remove archived') {
          requestPayload = {
            isArchived: false,

            _jv: {
              type: 'applicant_profile',
              id: this.applicantId,
            },
          }
          this.moveToArchived(requestPayload)
        }
      }
    },
    backFromArchived(id) {
      this.confirmation = 'Do you want to remove this applicant from archived?'
      this.$bvModal.show('delete')
      this.applicantId = id
      this.callFunction = 'remove archived'
    },
    download(id) {
      // var data = this.$store.getters['jv/get']('applicant_profile')
      //    var Item = data[id]
      /*  var status = 0
      if (Item.applyingMode === 'couple' || this.mode === 'couple_single_login')
        status =
          Item.completionStatus.applicant1 + Item.completionStatus.applicant2
      else status = Item.completionStatus.applicant1 + 9
      if (status === 19) { */
      this.downloadLoader = true
      axios({
        url: this.formapi[0] + '/forms/api/v1/export/' + id,
        method: 'GET',
        responseType: 'arraybuffer', // important
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'attachment',
          Authorization: 'JWT ' + services.getAuth(),
        },
      })
        .then((response) => {
          var data = this.$store.getters['jv/get']('applicant_profile')
          var Item = data[id]
          this.downloadLoader = false
          // console.log(response)
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'application/zip' })
          )
          //  window.open(url)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            Item.user.userProfile.fullName + '_' + id + '.zip'
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          if (error) {
            this.downloadLoader = false

            if (error.response !== undefined)
              this.message = error.response.data.errors[0].detail
            else
              this.message =
                'Something went wrong. Check your network connection'

            this.errorShow = true
            this.$bvToast.show('deleteRecord')

            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('deleteRecord')
              parent.message = null
            }, 6000)
          }
        })
      /*  } else {
        this.$bvModal.show('downloadCandidateForms')
      } */
    },
    callInvitation(id) {
      this.options = []
      this.selected = []
      var data = this.$store.getters['jv/get']('applicant_profile')
      var Item = data[id]

      // var option=[{text:Item.user.userProfile.fullName+'('+Item.user.email+')',value:'applicant1'}]
      this.options.push({
        text: Item.user.userProfile.fullName + '(' + Item.user.email + ')',
        value: 'applicant1',
      })
      if (Item.applyingMode === 'couple')
        this.options.push({
          text:
            Item.partner.userProfile.fullName + '(' + Item.partner.email + ')',
          value: 'applicant2',
        })
      this.confirmation =
        'Do you want to resend invitation to the following applicant(s)?'

      this.applicantId = id
      this.callFunction = 'resend'
      this.$bvModal.show('delete')
    },
    callArchived(id) {
      this.confirmation = 'Do you want to move this applicant to archived?'

      this.applicantId = id
      this.callFunction = 'archived'
      this.$bvModal.show('delete')
    },
    resendInvitation() {
      if (this.selected.length > 0) {
        var applicant1 = false
        var applicant2 = false
        if (
          this.selected[0] === 'applicant1' ||
          this.selected[1] === 'applicant1'
        )
          applicant1 = true
        if (
          this.selected[0] === 'applicant2' ||
          this.selected[1] === 'applicant2'
        )
          applicant2 = true
        var requestPayload = {
          applicant1: applicant1,
          applicant2: applicant2,

          _jv: {
            type: 'resend_invitation',
            id: this.applicantId,
          },
        }
        this.$store
          .dispatch('jv/post', [
            requestPayload,
            {
              url: '/applicant/' + this.applicantId + '/invitation/resend',
              headers: services.getHeaderAuthorization(),
            },
          ])
          .then((response) => {
            this.$bvModal.hide('delete')
            //  console.log(response._jv.json.data.detail)

            this.message = response._jv.json.data.detail
            this.errorShow = false
            this.$bvToast.show('deleteRecord')

            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('deleteRecord')
              parent.message = null
            }, 6000)
          })
          .catch((error) => {
            if (error) {
              this.$bvModal.hide('delete')
              if (error.response !== undefined)
                this.message = error.response.data.errors[0].detail
              else
                this.message =
                  'Something went wrong. Check your network connection'

              this.errorShow = true
              this.$bvToast.show('deleteRecord')

              var parent = this
              setTimeout(() => {
                parent.errorShow = false
                parent.$bvToast.hide('deleteRecord')
                parent.message = null
              }, 6000)
            }
            //   console.log(error)
          })
      } else {
        //   console.log('validate')
        this.resendValidation = true
      }
    },

    edit(id) {
      // this.$emit('edit', id)

      this.$router.push({ name: 'form', params: { id: id } })
    },
    deleteApplicant(id) {
      this.confirmation = 'Do you want to delete this record?'

      this.deleteId = id
      this.callFunction = 'delete'
      this.$bvModal.show('delete')
    },
    deleteRecord() {
      var id = this.deleteId

      this.$store
        .dispatch('jv/delete', [
          'applicant_profile',
          {
            url: '/applicant/profile/' + id + '/force_delete',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then(() => {})
        .catch((err) => {
          this.message = err.response.data.errors[0].detail
          this.errorShow = true
          this.$bvToast.show('deleteRecord')

          var parent = this
          setTimeout(() => {
            parent.errorShow = false
            parent.$bvToast.hide('deleteRecord')
            parent.message = null
          }, 6000)
        })
      this.$store.commit('jv/deleteRecord', {
        _jv: { type: 'applicant_profile', id: id },
      })
      this.message = 'Requested record is deleted'
      this.$bvModal.hide('delete')
      this.$bvToast.show('deleteRecord')
      var parent = this
      setTimeout(() => {
        parent.errorShow = false
        parent.$bvToast.hide('deleteRecord')
        parent.message = null
      }, 6000)
      var check = this.$store.getters['jv/get']('applicant_profile')
      this.setPermission(check)
    },
    searchItem() {
      // if(this.currentTab)
      if (this.search !== null && this.search !== '') {
        this.preloader = true
        var statusFilter = ''

        if (this.currentStatus === 'archived')
          statusFilter = 'filter[isArchived]=true'
        else if (this.currentStatus === 'all')
          statusFilter = 'filter[isArchived]=false'
        else
          statusFilter =
            'filter[isArchived]=false&filter[status]=' + this.currentStatus
        statusFilter =
          statusFilter +
          '&include=user,partner&filter[search]=' +
          this.search +
          this.loadLocation

        this.getUsers('applicant/profile?' + statusFilter)
      }
    },
    getData(to) {
      var link = this.links[to]
      if (link !== null) {
        var splites = link.split('/v1')

        this.getUsers(splites[1], this.currentTab)
      }
    },
    editApplicant(id) {
      this.$emit('applicant', { id: id })
    },
    getUsers(url) {
      this.$store.commit('jv/clearRecords', {
        _jv: { type: 'applicant_profile' },
      })
      this.permission = []
      // console.log('here')
      this.loading = true

      this.$store
        .dispatch('jv/get', [
          'applicant_profile',
          {
            url: url,
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.links = response._jv.json.links
          this.totalCount = response._jv.json.meta.pagination.count
          var check = {}

          check = this.$store.getters['jv/get']('applicant_profile')

          this.loading = false
          this.setPermission(check)
        })
    },

    setPermission(check) {
      this.permissions = []

      var id = Object.keys(check)

      var data = []

      for (var i = 0; i < id.length; i++) {
        //  data['applyingMode'] = check[id[i]].applyingMode

        data['email'] = check[id[i]].user.email
        data['status'] =
          check[id[i]].status.charAt(0).toUpperCase() +
          check[id[i]].status.slice(1)
        data['created_at'] = check[id[i]].created.split('T')[0]
        data['action'] = ''
        data['applyingMode'] = check[id[i]].applyingMode
        data['partner'] = check[id[i]].partner.userProfile

        data['applicant1Status'] = Math.round(
          (check[id[i]].completionStatus.applicant1 / 10) * 100
        )
        if (check[id[i]].partner.email !== undefined) {
          data['partner']['email'] = check[id[i]].partner.email
          data['applicant2Status'] = Math.round(
            (check[id[i]].completionStatus.applicant2 / 9) * 100
          )
        }

        data['fullName'] = check[id[i]].user.userProfile.fullName
        data['phoneNumber'] = check[id[i]].user.userProfile.phoneNumber
        data['location'] =
          check[id[i]].user.userProfile.location === 'GB'
            ? 'United Kingdom'
            : 'Scotland'
        data['id'] = id[i]
        this.permissions.push(data)
        data = []
      }

      //    console.log(this.permissions)
    },
  },
}
</script>
<template>
  <div ref="candidatelist">
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper" class="pb30-sm">
        <div :class="$style.profileSettings">
          <div :class="$style.bodyContent">
            <div :class="$style.breadCrumbWraper">
              <h4
                >Applicant
                <BIcon
                  :class="$style.actionIcon"
                  class="mr5"
                  icon="chevron-right"
                ></BIcon>
                <span>List</span>
              </h4>
            </div>
          </div>
          <div class="clear"></div>
          <div :class="$style.form">
            <div :class="$style.candidateAction">
              <div
                :class="[$style.searchCandidate, $style.inputField]"
                class="mr10 mb10-sm"
              >
                <input
                  v-model="search"
                  type="text"
                  name="search"
                  placeholder="Search"
                />
                <button
                  :class="$style.searchButton"
                  type="button"
                  @click="searchItem"
                  ><BIcon :class="$style.completed" icon="search"></BIcon
                ></button>
              </div>
              <div
                :class="[$style.filterCandidate, $style.inputField]"
                class="mr10 mb10-sm"
              >
                <div :class="$style.filterOptions">
                  <select v-model="location">
                    <option :value="null">Location</option>
                    <option value="all">All</option>
                    <option value="GB">UK</option>
                    <option value="GBS">Scotland</option>
                  </select>
                  <span :class="$style.searchButton"
                    ><BIcon :class="$style.completed" icon="geo-alt"></BIcon
                  ></span>
                </div>
              </div>
              <div class="FR">
                <button
                  :class="$style.createButton"
                  class="buttonCommon m0auto-xs db"
                  type="button"
                  @click="$emit('create', true)"
                  ><span>+</span> Invite Applicant
                </button>
              </div>
            </div>
            <div class="clear"></div>

            <div class="mt10" :class="$style.candidateWraper">
              <b-tabs content-class="" justified>
                <b-tab
                  ref="all"
                  title="All"
                  name="all"
                  :active="currentTab === 'all' ? true : false"
                  @click="getApplicants('#total-applicants')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'all'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table1"
                          show-empty
                          stacked="md"
                          responsive="sm"
                          borderless
                          head-variant="light"
                          :items="permissions"
                          :fields="fields"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                ref="allknob"
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}

                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'all'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'all'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >

                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="callArchived(row.item.id)"
                                  ><BIcon icon="archive" class="mr5"></BIcon
                                  >Move to archived</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <template>
                        <span
                          :class="$style.applicantsCount"
                          class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                          ><i
                            >Total applicants: <b>{{ totalCount }}</b></i
                          ></span
                        >
                      </template>
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="invited"
                  title="Invited"
                  name="invited"
                  :active="currentTab === 'invited' ? true : false"
                  @click="getApplicants('#invited')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'invited'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table2"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'invited'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'invited'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >

                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="joined"
                  name="joined"
                  title="Joined"
                  :active="currentTab === 'joined' ? true : false"
                  @click="getApplicants('#joined')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'joined'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table5"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'joined'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'joined'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >

                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="callArchived(row.item.id)"
                                  ><BIcon icon="archive" class="mr5"></BIcon
                                  >Move to archived</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="verified"
                  name="verified"
                  title="Verified"
                  :active="currentTab === 'verified' ? true : false"
                  @click="getApplicants('#verified')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'verified'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table4"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'verified'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'verified'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >

                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="callArchived(row.item.id)"
                                  ><BIcon icon="archive" class="mr5"></BIcon
                                  >Move to archived</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="submitted"
                  name="submitted"
                  title="Submitted"
                  :active="currentTab === 'submitted' ? true : false"
                  @click="getApplicants('#submitted')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'submitted'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table5"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'submitted'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'submitted'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >

                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="callArchived(row.item.id)"
                                  ><BIcon icon="archive" class="mr5"></BIcon
                                  >Move to archived</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="rejected"
                  name="rejected"
                  title="Rejected"
                  :active="currentTab === 'rejected' ? true : false"
                  @click="getApplicants('#rejected')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'rejected'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table3"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'rejected'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'rejected'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >

                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="callArchived(row.item.id)"
                                  ><BIcon icon="archive" class="mr5"></BIcon
                                  >Move to archived</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  ref="archived"
                  name="archived"
                  title="Archived"
                  :active="currentTab === 'archived' ? true : false"
                  @click="getApplicants('#archived')"
                >
                  <div :class="$style.tabContentWrap">
                    <template v-if="currentTab === 'archived'">
                      <div :class="$style.rolesTable" class="mt10">
                        <b-table
                          v-if="loading"
                          :items="permissions"
                          :busy="loading"
                          class="mt-3"
                          outlined
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                          </template>
                        </b-table>
                        <b-table
                          v-else
                          id="my-table6"
                          show-empty
                          :per-page="perPage"
                          :current-page="currentPage"
                          stacked="lg"
                          responsive="sm"
                          borderless
                          :items="permissions"
                          :fields="fields"
                          head-variant="light"
                        >
                          <template v-slot:cell(firstApplicant)="row">
                            <span :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant1Status"
                                :stroke-width="10"
                                primary-color="#37d381"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{ row.item.fullName }}
                            <span :class="$style.subText">{{
                              row.item.email
                            }}</span>
                          </template>
                          <template v-slot:cell(secondApplicant)="row">
                            <span
                              v-if="row.item.partner !== undefined"
                              :class="$style.percentageKnob"
                              ><KnobControl
                                v-model="row.item.applicant2Status"
                                :stroke-width="10"
                                primary-color="#2082ff"
                                secondary-color="#d7d7d7"
                                :size="30"
                              ></KnobControl
                            ></span>
                            {{
                              row.item.partner !== undefined
                                ? row.item.partner.fullName
                                : '--'
                            }}
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined &&
                              row.item.applyingMode == 'couple'
                                ? row.item.partner.email
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(phoneNumber)="row">
                            <span :class="$style.subText">
                              {{ row.item.phoneNumber }}
                            </span>
                            <span :class="$style.subText">{{
                              row.item.partner !== undefined
                                ? row.item.partner.phoneNumber
                                : ''
                            }}</span>
                          </template>
                          <template v-slot:cell(location)="row">
                            {{ row.item.location }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <a
                              :id="row.item.id + 'archived'"
                              href="javascript:void(0)"
                              variant="primary"
                              :class="[$style.actionsBtn, $style.animate]"
                            >
                              <BIcon
                                icon="gear-fill"
                                :class="$style.actionIcon"
                              ></BIcon>
                            </a>
                            <b-popover
                              :target="row.item.id + 'archived'"
                              placement="bottom"
                              triggers="hover"
                              :class="$style.popoverWraper"
                              boundary-padding="1"
                            >
                              <b-list-group flush>
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="edit(row.item.id)"
                                  ><BIcon
                                    icon="pencil-square"
                                    class="mr5"
                                  ></BIcon
                                  >Edit Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  href="javascript:void(0)"
                                  @click="callInvitation(row.item.id)"
                                  ><BIcon icon="envelope" class="mr5"></BIcon
                                  >Resend Invitation</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="editApplicant(row.item.id)"
                                  ><BIcon icon="person" class="mr5"></BIcon>Edit
                                  Profile</b-list-group-item
                                >

                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="backFromArchived(row.item.id)"
                                  ><BIcon
                                    icon="backspace-reverse"
                                    class="mr5"
                                  ></BIcon
                                  >Remove from archived</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="editMenu"
                                  href="javascript:void(0)"
                                  @click="download(row.item.id)"
                                  ><BIcon icon="download" class="mr5"></BIcon
                                  >Download Forms</b-list-group-item
                                >
                                <b-list-group-item
                                  v-if="deleteMenu"
                                  href="javascript:void(0)"
                                  @click="deleteApplicant(row.item.id)"
                                  ><BIcon icon="trash" class="mr5"></BIcon
                                  >Delete</b-list-group-item
                                >
                              </b-list-group>
                            </b-popover>
                          </template>
                        </b-table>
                      </div>
                      <span
                        :class="$style.applicantsCount"
                        class="FR FL-sm ml20 ml0-sm mt10 mr15-sm "
                        ><i
                          >Total applicants: <b>{{ totalCount }}</b></i
                        ></span
                      >
                    </template>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
            <div class="">
              <nav
                v-if="links !== null"
                class="FL"
                aria-label="Page navigation pagination"
              >
                <ul class="pagination justify-content-end">
                  <li
                    class="page-item"
                    :class="
                      links.first === null || links.first == undefined
                        ? 'disabled'
                        : ''
                    "
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      :class="$style.linkText"
                      @click="getData('first')"
                      >First</a
                    >
                  </li>

                  <li
                    :class="
                      links['prev'] === null || links.prev === undefined
                        ? ['page-item disabled']
                        : ['page-item']
                    "
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      :class="$style.linkText"
                      @click="getData('prev')"
                      >Prev</a
                    >
                  </li>
                  <li
                    :class="
                      links.next === null || links.next === undefined
                        ? ['disabled page-item']
                        : ['page-item']
                    "
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      :class="$style.linkText"
                      @click="getData('next')"
                      >Next</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="
                      links.last === null || links.last === undefined
                        ? 'disabled'
                        : ''
                    "
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      :class="$style.linkText"
                      @click="getData('last')"
                      >Last
                    </a>
                  </li>
                </ul>
              </nav>

              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>

    <!-- Loader -->
    <div v-if="downloadLoader" :class="$style.loader">
      <svg
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="64px"
        height="64px"
        viewBox="0 0 128 128"
        xml:space="preserve"
      >
        <g>
          <path
            d="M78.75 16.18V1.56a64.1 64.1 0 0 1 47.7 47.7H111.8a49.98 49.98 0 0 0-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0 1 47.7-47.7V16.2a49.98 49.98 0 0 0-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 0 1 1.8 78.5h14.63a49.98 49.98 0 0 0 33.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 0 1-47.7 47.7v-14.63a49.98 49.98 0 0 0 33.08-33.07z"
            fill="#ff6017"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 64 64"
            to="-90 64 64"
            dur="400ms"
            repeatCount="indefinite"
          ></animateTransform>
        </g>
      </svg>
    </div>
    <!-- Loader -->

    <!--Address Modal popup -->
    <div> </div>
    <!--Address Modal popup -->

    <!--Profile upload Modal popup -->
    <div>
      <!-- <b-button v-b-modal.modal-profile-upload>Launch centered modal</b-button> -->
      <div>
        <!-- <b-button v-b-modal.modal-profile-upload>Launch centered modal</b-button> -->
        <div>
          <b-modal
            id="delete"
            centered
            title="BootstrapVue"
            hide-header
            hide-footer
            size="md"
            :class="$style.modalOverall"
          >
            <div :class="[$style.modalWraper, $style.planeModal]">
              <div :class="$style.modalHeader">
                <h3 :class="$style.modalTitle">Confirmation</h3>
                <span :class="$style.modalIcon"></span>
              </div>
              <div class="clear"></div>
              <div :class="$style.modalBody">
                <p :class="$style.modalText">{{ confirmation }}</p>
                <b-form-group
                  v-if="callFunction == 'resend'"
                  class="position-relative"
                >
                  <b-form-checkbox
                    v-for="option in options"
                    :key="option.value"
                    v-model="selected"
                    :value="option.value"
                    :class="$style.checkboxWrap"
                    name="flavour-4a"
                    inline
                  >
                    {{ option.text }}
                  </b-form-checkbox>
                  <span v-if="resendValidation" :class="$style.error"
                    >Please select applicant to re-send invitation</span
                  >
                </b-form-group>

                <div class="clear"></div>
                <div :class="[$style.buttonWrapper]" class="tc mt30">
                  <button
                    type="button"
                    class="buttonCommon buttonCancel button mr10"
                    @click="$bvModal.hide('delete')"
                  >
                    Cancel
                  </button>
                  <button
                    class="buttonCommon buttonPrimary button"
                    type="button"
                    @click="callMethod(callFunction)"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <div>
          <b-modal
            id="downloadCandidateForms"
            centered
            title="BootstrapVue"
            hide-header
            hide-footer
            size="md"
            :class="$style.modalOverall"
          >
            <div :class="[$style.modalWraper, $style.planeModal]">
              <div :class="$style.modalHeader">
                <h3 :class="$style.modalTitle">Information</h3>
                <span :class="$style.modalIcon"></span>
              </div>
              <div class="clear"></div>
              <div :class="$style.modalBody">
                <p :class="$style.modalText"
                  >This applicant have some incomplete forms. You can download
                  it once they are completed.</p
                >
                <div class="clear"></div>
                <div :class="[$style.buttonWrapper]" class="tc mt30">
                  <button
                    type="button"
                    class="buttonCommon buttonCancel button mr10"
                    @click="$bvModal.hide('downloadCandidateForms')"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </div>

      <div :class="$style.toasterMainWrap">
        <b-toast id="deleteRecord" solid no-auto-hide>
          <div
            class="d-flex"
            :class="
              errorShow
                ? [$style.loginToasterWraper, $style.error]
                : [$style.loginToasterWraper, $style.success]
            "
          >
            <div :class="$style.toasterLeft">
              <BIcon
                icon="chat-square-dots-fill"
                :class="$style.toasterIcon"
              ></BIcon>
            </div>
            <div :class="$style.toasterRight">
              <strong class="mr-auto" :class="$style.toasterHeader"
                >Notice!</strong
              >
              <p :class="$style.toasterContent">{{ message }}</p>
            </div>
            <div class="clear"></div>
          </div>
        </b-toast>
      </div>
    </div>
    <!--Profile upload Modal popup -->
  </div>
</template>
<style lang="scss" module>
@import '@design';
.loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.5);

  svg {
    position: fixed;
    top: calc(50vh - 32px);
    left: calc(50vw - 32px);
  }
}
.percentageKnob {
  display: block;
  float: right;
  margin-left: 10px;
  text {
    font-size: 30px !important;
  }
}

::placeholder {
  color: #c3c8cc;
}

.checkboxWrap {
  display: block !important;
  max-width: 350px;
  margin: 0 auto;

  label {
    font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 14px;
    color: #4b545e !important;
  }
}

.applicantsCount {
  font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 14px;
  color: #4a89dc;
}

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  &.planeModal {
    .modalHeader {
      padding: 25px 30px 5px 30px;
      background: #fff;
      border: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .modalIcon {
      display: block;
      width: 100px;
      height: 100px;
      margin: 20px auto;
      background: url('~@assets/images/information.png') no-repeat;
      transform: scale(0.9);
      transform-origin: top;
    }
    .modalTitle {
      float: none;
      text-align: center;
    }
    .modalText {
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: #818284;
      text-align: center;
    }
    .modalBody {
      padding: 0 30px 40px 30px;
    }
  }
}
// Modal
.error {
  position: absolute;
  bottom: -17px;
  left: 0;
  z-index: 1;
  width: auto !important;
  padding: 3px 10px;
  font-size: 13px;
  color: #fff !important;
  background: #ec6e63;
  border-radius: 5px;

  &::after {
    position: absolute;
    top: -4px;
    left: 10px;
    width: 10px;
    height: 10px;
    content: '';
    background: #ec6e63;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

.mainWraper {
  width: 100%;
  min-height: calc(100vh - 55px);
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  min-height: calc(100vh - 85px);
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

.popoverWraper {
  padding: 0 !important;
}
.searchCandidate {
  position: relative;
  float: left;
  width: 200px;
  overflow: hidden;
  border-radius: 50px;

  input {
    padding: 8px 10px;
    background: #f8fafb;
    border-color: #f9ba9f !important;
    border-radius: 50px;
  }

  button {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding: 8px 14px;
    color: #fff;
    background: #ff5d16;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

    svg {
      font-size: 17px;
    }
  }
}

.filterCandidate {
  position: relative;
  float: left;
  width: 200px;
  overflow: hidden;
  border-radius: 50px;

  .filterOptions {
    position: relative;
    width: 100%;
    overflow: hidden;
    // border: 1px solid $color-field-border !important;
    border-radius: 50px;

    span {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      padding: 9px 14px;
      color: #fff;
      pointer-events: none;
      background: #ff5d16;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;

      svg {
        font-size: 17px;
      }
    }

    select {
      width: 100%;
      padding: 8px 10px;
      font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: $field-title-font-size;
      color: $color-field-text;
      background: $color-filed-background;
      border: 1px solid #f9ba9f;
      border-radius: 50px;
      transition: all ease-in-out 0.3s;
    }
  }

  &:focus-within {
    transition: all ease-in-out 0.3s !important;
    select {
      background: $color-field-active !important;
      border: 1px solid $color-field-border-active !important;
      transition: all ease-in-out 0.3s;
    }
  }
}

.createButton {
  padding: 8px 20px !important;
  font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px !important;
  color: #fff;
  background-color: #ff5d16;
  border-radius: 50px !important;
}

.actionsBtn {
  position: relative;
  display: block;
  width: 26px;
  height: 26px;
  color: #455d73;
  background: #fff !important;
  border: 1px solid #455d73 !important;
  border-radius: 50px !important;

  .actionIcon {
    position: absolute;
    top: 5px;
    left: 5px;
    color: #455d73;
    transition: all ease-in-out;
    transform: rotate(0deg) 0.2s;
  }

  &.animate:hover {
    .actionIcon {
      color: #455d73;
      transition: all ease-in-out 0.2s;
      transform: rotate(90deg);
    }
  }
}

// Table
.table {
  margin-bottom: 0 !important;
}
.rolesTable {
  display: block;
  width: 100%;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 10px;

  table {
    margin: 0 !important;
    border: 0 !important;
  }

  th {
    background-color: #f9f9fb !important;
    border: none !important;
    border-bottom: 1px solid #e8e8e8 !important;
    div {
      font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji !important;
      font-size: 15px !important;
      color: #4b545e !important;
    }
  }

  td {
    position: relative;
    padding: 15px !important;

    div {
      font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji !important;
      font-size: 14px !important;
      color: #4b545e !important;
      word-break: break-word;
      vertical-align: middle;
    }

    .subText {
      display: block;
      font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji !important;
      font-size: 12px !important;
      color: #8c8c8c !important;
      word-break: break-word;
      vertical-align: middle;
    }
  }

  tr:nth-child(even) {
    background-color: #f9f9fb;
  }

  tr:nth-child(odd) {
    background-color: #fff;
  }

  .actionList {
    z-index: 10;
  }
}

// Table

.form {
  padding: 20px 30px;
}

// Page Title - Info text
.bodyContent {
  float: left;
  width: 100%;

  .contentHeader {
    font-family: 'OpenSansBold', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 22px;
    color: $color-main-title;
  }

  .contentInfo {
    font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 13px;
    color: $color-sub-title;
  }
}

// Page Title - Info text

.profileSettings {
  float: left;
  width: 100%;
}

@media (max-width: 767px) {
  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .profileSettings {
    padding: 0;
  }
  .mainWraper {
    padding: 0 !important;
  }
  .createButton {
    display: block;
    width: 38px;
    height: 38px;
    padding: 0 !important;
    font-size: 25px !important;
    line-height: 38px;
    color: transparent;
    border-radius: 50px !important;

    span {
      color: #fff !important;
    }
  }

  .rolesTable {
    table {
      tbody {
        td::after {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 1px;
          content: '';
          background: #ececec;
        }
      }
    }
  }
}
</style>
